import * as moment from 'moment';

export class DataUtil {

    public static getDataEHoraAtualComoString() {
        return moment().format('DD/MM/YYYY HH:mm:ss');
    }

}
